<template>
  <div class="relative">
    <div class="bg-gray-700 p-4">
      <div class="max-w-7xl 3xl:max-w-8xl mx-auto">
        <div class="grid grid-cols-10">
          <div class="col-span-10 md:col-span-2 mb-4 md:mb-0">
            <img v-if="sitename === 'reflextrader'" alt="Reflextrader" class="w-56"
              src="@/assets/images/exchange/logo-light.svg" />
            <img v-else alt="Cointopay" src="@/assets/logo-light.svg" />
          </div>
          <div class="col-span-10 md:col-span-2 text-white mb-4 md:mb-0">
            <h2 class="uppercase text-lg font-bold">{{ translate('misc.company') }}</h2>
            <ul class="list-disc list-inside">
              <li>
                <router-link class="hover:text-gray-300" :to="{ name: 'payments' }">Payments</router-link>
              </li>
              <li>
                <router-link class="hover:text-gray-300" :to="{ name: 'about' }">About us</router-link>
              </li>
              <li>
                <router-link class="hover:text-gray-300" :to="{ name: 'terms' }">Terms and Privacy</router-link>
              </li>
              <li>
                <a class="hover:text-gray-300" target="_blank"
                  href="https://cdn-eur.s3.eu-west-1.amazonaws.com/Coinplusgroup-sro-Privacy-Policy.pdf">Privacy
                  Policy</a>
              </li>
              <li>
                <a class="hover:text-gray-300" href="https://docs.cointopay.com" target="_blank">API</a>
              </li>
              <li>
                <router-link class="hover:text-gray-300" :to="{ name: 'newsletter' }">Newsletter</router-link>
              </li>
            </ul>
          </div>
          <div class="col-span-10 md:col-span-2 text-white mb-4 md:mb-0">
            <h2 class="uppercase text-lg font-bold">{{ translate('misc.services') }}</h2>
            <ul class="list-disc list-inside">
              <li>
                <a class="hover:text-gray-300" href="https://cointopay.com/wallet">Wallet</a>
              </li>
              <li>
                <a class="hover:text-gray-300" href="https://cointopay.com/account/shopping">Checkout</a>
              </li>
              <li>
                <a class="hover:text-gray-300" href="https://exchange.cointopay.com/">Trading</a>
              </li>
              <li>
                <router-link class="hover:text-gray-300" :to="{ name: 'trade-bots' }">TradingBots</router-link>
              </li>
              <li>
                <a class="hover:text-gray-300" href="https://banckrypto.com/">Banckrypto</a>
              </li>
              <li>
                <a class="hover:text-gray-300" href="https://cointopay.com/account/pos">POS</a>
              </li>
              <li>
                <a class="hover:text-gray-300" href="https://cointopay.com/account/social">Donations</a>
              </li>
              <li>
                <a class="hover:text-gray-300" href="https://cointopay.com/account/pos/office">Posercart Ecommerce</a>
              </li>
            </ul>
          </div>
          <div class="col-span-10 md:col-span-3 text-white mb-4 md:mb-0">
            <h2 class="uppercase text-lg font-bold">{{ translate('misc.social') }}</h2>
            <ul class="social">
              <li v-for="(network, index) in networks" :key="index">
                <a :class="nameToClass(network.name)" :href="network.url"
                  class="m-1 w-12 h-12 border-2 border-white rounded flex items-center justify-center" target="_blank">
                  <img :src="require(`../../assets/images/networks/${network.icon}.svg`)" alt="" class="w20" />
                </a>
              </li>
            </ul>
          </div>
          <div class="col-span-10 md:col-span-1 text-white mb-4 md:mb-0">
            <h2 class="uppercase text-lg font-bold">Apps</h2>
            <ul class="stores">
              <li>
                <a class="app relative" href="https://play.google.com/store/apps/details?id=com.cointopay.app"
                  target="_blank">
                  <div class="absolute w-48 h-48 rounded p-2 shadow-xl bg-gray-50 z-10 bottom-1 left-0">
                    <QRCodeVue3 :width="qrOptions.width" :height="qrOptions.height" :qr-options="qrOptions.qrOptions"
                      :background-options="qrOptions.backgroundOptions"
                      image="data:image/png;base64,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"
                      :dots-options="qrOptions.dotsOptions" :corners-dot-options="qrOptions.cornersDotOptions"
                      :corners-square-options="qrOptions.cornersSquareOptions"
                      value="https://play.google.com/store/apps/details?id=com.cointopay.app"></QRCodeVue3>
                  </div>
                  <img alt="Play store" src="@/assets/images/play_store.png" />
                </a>
              </li>
              <li>
                <a class="app relative" href="https://itunes.apple.com/us/app/ctp-wallet/id1450194783?ls=1&mt=8"
                  target="_blank">
                  <div class="absolute w-48 h-48 rounded p-2 shadow-xl bg-gray-50 z-10 bottom-1 left-0">
                    <QRCodeVue3 :width="qrOptions.width" :height="qrOptions.height" :qr-options="qrOptions.qrOptions"
                      image="data:image/png;base64,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"
                      :background-options="qrOptions.backgroundOptions" :dots-options="qrOptions.dotsOptions"
                      :corners-dot-options="qrOptions.cornersDotOptions"
                      :corners-square-options="qrOptions.cornersSquareOptions"
                      value="https://itunes.apple.com/us/app/ctp-wallet/id1450194783?ls=1&mt=8"></QRCodeVue3>
                  </div>
                  <img alt="App store" src="@/assets/images/app_store.svg" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gray-900 p-2 text-white">
      <div class="max-w-7xl 3xl:max-w-8xl mx-auto">
        <div class="grid grid-cols-3">
          <div class="col-span-3 lg:col-span-1 flex items-center mb-3 md:mb-0">
            <div class="mx-auto md:ml-44">
              <!-- Language dropdown -->
              <lang-dropdown></lang-dropdown>
            </div>
          </div>
          <div class="col-span-3 lg:col-span-1 text-left md:text-center mb-3 md:mb-0">
            <!-- TrustBox widget - Micro Review Count -->
            <div class="trustpilot-widget" data-locale="en-US" data-template-id="5419b6a8b0d04a076446a9ad"
              data-businessunit-id="5cd2fcc977f0fd0001a792c0" data-style-height="24px" data-style-width="100%"
              data-theme="dark">
              <a href="https://www.trustpilot.com/review/cointopay.com" target="_blank" rel="noopener">Trustpilot</a>
            </div>
            <!-- End TrustBox widget -->
          </div>
          <div class="col-span-3 lg:col-span-1 text-left md:text-right">
            <router-link class="mr-3 hover:underline text-sm" :to="{ name: 'system-status' }">System Status
            </router-link>
            &copy;{{ year }} Cointopay.com, All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gray-900 p-2 text-white">
      <div class="max-w-7xl 3xl:max-w-8xl mx-auto">
        <div class="text-center text-sm">
          <p>Cointopay.com is regulated by the authorities of the
            <a href="https://fau.gov.cz/en" target="_blank" class="underline cursor-pointer">Czech Republic</a>
            in the European Union <a
              href="https://or.justice.cz/ias/ui/rejstrik-firma.vysledky?subjektId=1202469&typ=PLATNY"
              class="underline cursor-pointer" target="_blank">(VASP license)</a>
          </p>
        </div>
      </div>
    </div>
    <!-- Chat Box -->
    <chat></chat>
  </div>
</template>

<script setup>
import QRCodeVue3 from 'qrcode-vue3';
import { computed, inject } from 'vue';
import qrCodeOptions from '@/qrOptions';
import LangDropdown from '@/components/navbar/LangDropdown';
import { useStore } from 'vuex';
import Chat from '@/views/Chat.vue';

const store = useStore();

const { qrOptions } = qrCodeOptions();
const networks = [
  {
    name: 'twitter',
    url: 'https://twitter.com/Cointopay',
    icon: 'twitter'
  },
  {
    name: 'linkedin',
    url: 'https://www.linkedin.com/in/cointopay-crypto-payments-42baa495/',
    icon: 'linkedin'
  },
  {
    name: 'facebook',
    url: 'https://www.facebook.com/CointopayInternational/',
    icon: 'facebook'
  },
  {
    name: 'pinterest',
    url: 'http://www.pinterest.com/ccryptop/pins/',
    icon: 'pinterest'
  },
  {
    name: 'reddit',
    url: 'https://www.reddit.com/r/Cointopay/',
    icon: 'reddit'
  },
  {
    name: 'youtube',
    url: 'https://www.youtube.com/channel/UC4zUepZUeuuS3tAoUXx93Kw/videos',
    icon: 'youtube'
  },
  {
    name: 'github',
    url: 'https://github.com/Cointopay',
    icon: 'github'
  },
  {
    name: 'discord',
    url: 'https://discord.gg/VbXchwu',
    icon: 'discord'
  },
  {
    name: 'telegram',
    url: 'https://t.me/cointopaycom',
    icon: 'telegram'
  },
  {
    name: 'rss',
    url: 'https://cointopay.com/RSS.jsp',
    icon: 'rss'
  }
];
const year = new Date().getFullYear();

const sitename = computed(() => store.state.sitename);

// Providers
const translate = inject('translate');

// Methods
const nameToClass = (value) => {
  return value.trim().toLowerCase().replace(/ /g, '-');
};
</script>

<style lang="scss" scoped>
ul.social {
  list-style-type: none;
  padding: 0;
  max-width: 280px;

  li {
    display: inline-block;

    a {
      &.twitter:hover {
        background: #099bcc;
        border-color: #099bcc;
      }

      &.linkedin:hover {
        background: #2e8cc2;
        border-color: #2e8cc2;
      }

      &.facebook:hover {
        background: #4672b3;
        border-color: #4672b3;
      }

      &.pinterest:hover {
        background: #c32524;
        border-color: #c32524;
      }

      &.reddit:hover {
        background: #ff4500;
        border-color: #ff4500;
      }

      &.youtube:hover {
        background: #cb322c;
        border-color: #cb322c;
      }

      &.github:hover {
        background: #333637;
        border-color: #333637;
      }

      &.rss:hover {
        background: #e97633;
        border-color: #e97633;
      }

      &.telegram:hover {
        background: #2AB5F6;
        border-color: #2AB5F6;
      }

      &.discord:hover {
        background: #8799F7;
        border-color: #8799F7;
      }

      img {
        width: 24px;
      }
    }
  }
}

ul.stores {
  padding: 0;
  list-style-type: none;

  li {
    margin-bottom: 16px;
    display: block;
    cursor: pointer;

    a {
      position: relative;

      div {
        display: none;
        transition: all 0.3s ease-in-out;
      }

      &:hover {
        div {
          display: block;
        }
      }
    }

    img {
      width: 200px;

      @media (min-width: 768px) and (max-width: 960px) {
        width: 160px;
      }
    }
  }
}
</style>
